<template>
  <nav :class="routeContainerWidth" class="mx-auto  mt-20 w-full px-4 sm:px-6 lg:px-8" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <template           :key="index"
      v-for="(breadcrumb, index) in breadcrumbs">
        <li
          class="breadcrumb-item"
          :class="{ active: index === breadcrumbs.length - 1 }"
        >
          <template v-if="index !== breadcrumbs.length - 1 && breadcrumb.nameRoute">
            <router-link
              class="link-green"
              :to="{ name: breadcrumb.nameRoute }">
              {{ breadcrumb.name }}
            </router-link>
          </template>
          <span v-else-if="breadcrumb.name">
            {{ breadcrumb.name }}
          </span>
        </li>
        
        <template v-if="index < breadcrumbs.length - 1 && breadcrumbs[index + 1]?.name">
          <li :key="`separator-${index}`" class="grey-4-color">
            <InlineSvg
              style="height: 14px; margin-left: 8px; margin-right: 8px; vertical-align: middle;"
              src="/img/arrow-breadcrumb.svg"
            ></InlineSvg>
          </li>
        </template>
      </template>
    </ol>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      breadcrumbs: [],
      cachedWidth: null
    }
  },
  computed: {
    routeContainerWidth() {
      const width = this.$route?.meta?.breadcrumbWidth

      if (width !== this.cachedWidth) {
        this.cachedWidth = width
      }

      return this.cachedWidth || 'max-w-7xl'
    }
  },
  watch: {
    $route() {
      this.generateBreadcrumbs();
    },
  },
  mounted() {
    this.generateBreadcrumbs();
  },
  methods: {
    generateBreadcrumbs() {
      const matchedRoutes = this.$route.matched;

      this.breadcrumbs = matchedRoutes.map(route => {
        if (Array.isArray(route.meta?.breadcrumb)) {
          return route.meta.breadcrumb.map(crumb => ({
            name: this.$t(crumb.name),
            nameRoute: crumb.route
          }));
        }

        let nameRoute = route.name;

        if (route.name === 'contract.cabinet') {
          nameRoute = null;
        }

        return {
          name: route.meta?.breadcrumb ? this.$t(route.meta?.breadcrumb): null,
          nameRoute: nameRoute
        };
      }).flat().filter(crumb => crumb.name);
    }
  },
};
</script>

<style scoped>
.breadcrumb {
  display: inline-flex;
  align-items: center;
  list-style: none;
  padding: 0;
}

.breadcrumb-item a {
  text-decoration: none;
}
.breadcrumb-item.active {
  font-weight: bold;
}
</style>
